var ServerSentResourceType = /* @__PURE__ */ ((ServerSentResourceType2) => {
  ServerSentResourceType2["ANAMNESIS"] = "ANAMNESIS";
  ServerSentResourceType2["APPOINTMENT"] = "APPOINTMENT";
  ServerSentResourceType2["CALL_TASK"] = "CALL_TASK";
  ServerSentResourceType2["TEXT_MESSAGE"] = "TEXT_MESSAGE";
  ServerSentResourceType2["CONVERSATION"] = "CONVERSATION";
  ServerSentResourceType2["TODO_LIST_TASK"] = "TODO_LIST_TASK";
  ServerSentResourceType2["PATIENT"] = "PATIENT";
  ServerSentResourceType2["OPEN_APPOINTMENT"] = "OPEN_APPOINTMENT";
  ServerSentResourceType2["PATIENT_CREDITWORTHINESS"] = "PATIENT_CREDITWORTHINESS";
  ServerSentResourceType2["CODE"] = "CODE";
  return ServerSentResourceType2;
})(ServerSentResourceType || {});
export {
  ServerSentResourceType
};
